var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePagination',{staticClass:"custom-pagination",class:{
    'no-prev': _vm.dataValue === 1,
    'no-next': _vm.dataValue === _vm.totalRows,
  },attrs:{"records":_vm.totalRows,"per-page":_vm.perPage,"options":{
    chunk: _vm.visiblePageButtons,
    chunksNavigation: { center: true, },
    edgeNavigation: _vm.totalRows > (_vm.visiblePageButtons*_vm.perPage),
    texts: {
      count: '',
      first: 1,
      last: Math.ceil(_vm.totalRows/_vm.perPage),
      prevPage: _vm.angleLeft,
      nextPage: _vm.angleRight,
    },
  }},on:{"paginate":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }